import { gql } from "@apollo/client";

export const InstalledBaseEventList = gql`
    query InstalledBaseEventList (
        $filter: InstalledBaseEventListFilter
        $search: SearchInput
        $pagination: Pagination
        $sort: InstalledBaseEventListSort
    ) {
        installedBaseEventList (filter: $filter, search: $search) {
            total
            installedBaseEvents (pagination: $pagination, sort: $sort) {
                id
                insert
                eventType
                eventCategory
                message
                data
                user {
                    id
                    name
                }
                asset {
                    id
                    serialNumber
                    product {
                        id
                        status
                        name
                        productCode
                    }
                }
                assetLocation {
                    id
                    warrantyEndDate
                    owner {
                        id
                        name
                    }
                }
                installedBaseNode {
                    id
                    pathNodes {
                        id
                        title
                        nodeType {
                            key
                        }
                    }
                }
                # Only on InstalledBaseEvent - the list returns EventInterface (IBM-1062)
                ... on InstalledBaseEvent {
                    attributeList {
                        attributes {
                            id
                            property {
                                id
                                alias
                                preferredName
                            }
                            value
                            displayValue
                        }
                    }
                }
            }
        }
    }
`;
